enum CoursesActions {
    FETCH_LIST = "coursesFetchList",
    GET_ITEM = "coursesGetItem",
    CREATE_ITEM = "coursesCreateItem",
    UPDATE_ITEM = "coursesUpdateItem",
    DELETE_ITEM = "coursesDeleteItem",
    REFRESH_LIST = "coursesRefreshList",
    UPDATE_DESCRIPTION = "coursesUpdateDescription",
    FETCH_TYPES = "coursesFetchTypes",
    GET_TYPE = "coursesGetType",
    CREATE_TYPE = "coursesCreateType",
    UPDATE_TYPE = "coursesUpdateType",
    DELETE_TYPE = "coursesDeleteType",
    FETCH_EXPERTISES = "coursesFetchExpertises",
    GET_EXPERTISE = "coursesGetExpertise",
    CREATE_EXPERTISE = "coursesCreateExpertise",
    UPDATE_EXPERTISE = "coursesUpdateExpertise",
    DELETE_EXPERTISE = "coursesDeleteExpertise",
    FETCH_LOCATIONS = "coursesFetchLocations",
    CREATE_LOCATION = "coursesCreateLocation",
    UPDATE_LOCATION = "coursesUpdateLocation",
    DELETE_LOCATION = "coursesDeleteLocation",
    FETCH_PARTNERS = "coursesFetchPartners",
    CREATE_PARTNER = "coursesCreatePartner",
    UPDATE_PARTNER = "coursesUpdatePartner",
    DELETE_PARTNER = "coursesDeletePartner",
    FETCH_INSTRUCTORS = "coursesFetchInstructors",
    FETCH_SUBSCRIPTION_PACKAGES = "coursesFetchSubscriptionPackages",
    FETCH_BOOKINGS = "coursesFetchBookings",
    ADD_BOOKING = "coursesAddBooking",
    CONFIRM_BOOKING = "coursesConfirmBooking",
    REFUSE_BOOKING = "coursesRefuseBooking",
    REMOVE_BOOKING = "coursesRemoveBooking",
    REMIND_BOOKING = "coursesRemindBooking",
    FETCH_DASHBOARD_BOOKINGS = "coursesFetchDashboardBookings",
    SEND_MAIL = "coursesSendMail",
    GET_EMAIL_TEMPLATE = "coursesGetEmailTemplate",
    DOWNLOAD_PDF = "coursesDownloadPdf",
    CREATE_INVOICE = "coursesCreateInvoice",
    EXPORT_PARTICIPANTS = "coursesExportParticipants",
    EXPORT_REGISTRATIONS = "coursesExportRegistrations",
    FETCH_DOCUMENTS = "coursesFetchDocuments",
    UPLOAD_DOCUMENT = "coursesUploadDocument",
    ADD_DOCUMENT = "coursesAddDocument",
    DELETE_DOCUMENT = "coursesDeleteDocument",
    SET_PRESENCE_STATE = "coursesSetPresenceState",
    SET_VISIBLE_STATE = "coursesSetVisibleState",
    COPY_COURSE = "coursesCopyCourse",
    SET_PARTICIPANT_NAME = "coursesSetParticipantName",
    SET_PARTICIPANT_ROLE = "coursesSetParticipantRole",
    SET_PARTICIPANT_EMAIL = "coursesSetParticipantEmail",
    UPLOAD_IMAGE = "coursesUploadImage",
    DELETE_IMAGE = "coursesDeleteImage",
    GET_PARTNER = "coursesGetPartner",
    UPDATE_PARTNER_DETAILS = "coursesUpdatePartnerDetails",
    DOWNLOAD_INVOICE = "coursesDownloadInvoice",
    WAITING_BOOKING = "coursesWaitingBooking",
    UPLOAD_EXPERTISE_FILE = "coursesUploadExpertiseFile",
    DELETE_EXPERTISE_FILE = "coursesDeleteExpertiseFile",
}

enum CoursesMutation {
    SET_RENDER_UPDATE = "coursesListRenderNeeded",
    SET_LIST_RESULT = "coursesListResult"
}

export {CoursesActions, CoursesMutation};
